module.exports = __webpack_public_path__ + "static/media/utensilios_500x325.5c582010.png";